import i18n from '@/lang/i18n'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ConfigurationIncidentsSeveritiesLaboratoriesResponse } from '@/modules/configurationModule/detail/incidents/incidents-severities/services/incidents-severities-laboratories.dto'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { incidentsSeveritiesLaboratoriesConfigurationServices } from '@/modules/configurationModule/detail/incidents/incidents-severities/services/incidents-severities-laboratories.service'
import { store } from '@/store/store'

export const columnsDefIncidentsSeveritiesGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.incidentSeverities'),
            field: 'incidentSeverity.name',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.NUMBER,
            headerName: i18n.tc('configuration.grid.daysToClosingDelay'),
            field: 'daysToClosingDelay',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.mandatoryNotifications'),
            field: 'mandatoryNotification',
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            flex: 1,
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface IncidentsSeveritiesGridState extends CrudModelPaginatorLaboratory<ConfigurationIncidentsSeveritiesLaboratoriesResponse> {
    labId: number
}
export const initialIncidentsSeveritiesGridState =
    (): IncidentsSeveritiesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.incidents.incidentsSeverities',
        columnsDef: columnsDefIncidentsSeveritiesGrid(),
        datasource: new PaginatorLaboratoryDatasource(incidentsSeveritiesLaboratoriesConfigurationServices, store.getters.labId),
        labId: store.getters.labId
    })
